import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CertificatesPrivateService, FeedMessageService, showSuccess } from '@services/index.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmCancelComponent } from '@shared/index.shared';
import { ErrorCode, Response, } from '@models/index.model';
import { finalize, Observable, take, tap } from 'rxjs';
import { environment } from '@environments/environment';
import { RemovePinReponse, RemovePinRequest } from '@models/certificates/certificates.model';

@Component({
    selector: 'app-dialog-private-cert-remove-pin2',
    templateUrl: './dialog-private-cert-remove-pin2.component.html',
    styles: [],
    standalone: false
})
export class DialogPrivateCertRemovePin2Component implements OnInit {
  public isMobile: boolean;
  tooltipTitle: any;
  sendingInfo: boolean = false;

  dataCurrentPin: string = '';

  hidePinCurrent: boolean = true;


  _removePin: any;
  removePinRequest: RemovePinRequest;

  constructor(
    public dialogRef: MatDialogRef<DialogPrivateCertRemovePin2Component>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    public translate: TranslateService,
    private _notify: FeedMessageService,
    private _privCertsServ: CertificatesPrivateService
  ) {
    this.isMobile = environment.platform === 'mobile';
    translate.get(['GLOBAL.TOOLTIP']).subscribe(res => {
      this.tooltipTitle = res['GLOBAL.TOOLTIP'];
    });
  }

  ngOnInit() {
  }

  sendRemovePIN() {
    this.removePIN().subscribe();
  }

  removePIN(): Observable<Response<RemovePinReponse>> {
    this.sendingInfo = true;
    this.removePinRequest = {
      personalCertificateId: this.data.id,
      currentPIN: this.dataCurrentPin
    }
    return this._privCertsServ.removePersonalCertificatePIN(this.removePinRequest).pipe(
      take(1),
      tap((res: Response<RemovePinReponse>) => {
        this._removePin = res;
        if (this._removePin.errorCode === ErrorCode.OK) {
          this._notify.feedBackResult(this._removePin.messageType, this._removePin.message, showSuccess);
          this.dialogRef.close(true);
        }
      }),
      finalize(() => {
        this.cleanPin();
        this.sendingInfo = false;
      })
    );
  }

  cleanPin() {
    this.dataCurrentPin = '';
  }

  cancelChanges() {
    const dialogRef = this.dialog.open(DialogConfirmCancelComponent, {
      width: '400px',
      data: {}
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.onNoClick();
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
